<template>
  <div>
    <div class="text-xs-right">
      <div>
        <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
      </div>
      <div>
        <v-layout row wrap class="pa-0 ma-0">
          <v-flex xs6 class="text-xs-left">
            <v-btn @click="branchReceiptDialog = true" outline>ตั้งค่าตัวอย่างใบเสร็จ</v-btn>
          </v-flex>
          <v-flex xs6>
            <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
            <v-btn :loading="exportloading" @click="exportxlsx" color="grey" outline>
              <em class="fas fa-file-export" />
              &nbsp; Export&nbsp;
            </v-btn>
            <v-btn @click="addBranch" depressed color="primary">ADD</v-btn>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <v-pagination
      :total-visible="15"
      v-model="pageNumber"
      @input="changePage"
      :length="pagelength"
    ></v-pagination>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td @click="showQrcode(props.item)">
            <em style="cursor: pointer; font-size: 21px" class="fas fa-qrcode" />
          </td>
          <td>
            {{ props.item.department_store_id }}
          </td>
          <td>
            {{ props.item.branch_id }}
          </td>
          <td>
            {{ props.item.department_store }}
          </td>
          <td>
            {{ props.item.branch }}
          </td>
          <td class="text-xs-right">
            <v-btn @click="editBranch(props.item)" icon> <v-icon>edit</v-icon></v-btn>
            <v-btn @click="deleteBranch(props.item)" icon> <v-icon>delete</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div>
      <v-dialog v-model="showEdit" persistent width="550px">
        <v-card v-if="showEdit">
          <BranchEdit
            @onsave="onsave"
            @close="showEdit = false"
            :edittype="edittype"
            :editdata="editdata"
          ></BranchEdit>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="qrdialog" width="350px" persisten>
      <v-card v-if="qrdialog" class="text-xs-center pb-4">
        <div class="text-xs-right">
          <v-btn @click="qrdialog = false" icon small>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div style="font-size: 28px; font-weight: 600">
          {{ qrdata.department_store }}
        </div>
        <div style="color: black">
          {{ qrdata.branch }}
        </div>
        <div>
          <v-img class="mx-auto" width="200px" :src="qrdata.qr_code"></v-img>
        </div>
        <div>
          <a :download="qrdata.branch_id + '.png'" :href="qrdata.qr_code">
            <v-btn color="primary" @click="gotolink(qrdata.qr_code)">Download</v-btn></a
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('ชื่อห้าง') }}</label>
                <input v-model="filter.departmentStore" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('รหัสของห้าง') }}</label>
                <input v-model="filter.departmentStoreId" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('ชื่อสาขา') }}</label>
                <input v-model="filter.branch" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('รหัสสาขาของห้าง') }}</label>
                <input v-model="filter.branchId" class="form-control" type="text" />
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onsearch" color="primary">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="branchReceiptDialog" width="700px" persistent>
      <v-card v-if="branchReceiptDialog">
        <BranchReceipt @close="branchReceiptDialog = false"></BranchReceipt>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import { mapGetters } from 'vuex'
import BranchEdit from './BranchEdit.vue'
import BranchReceipt from './BranchReceipt.vue'
import VueQr from 'vue-qr'
import * as XLSX from 'xlsx'
export default {
  components: {
    BranchEdit,
    VueQr,
    importxlsx,
    exportxlsx,
    BranchReceipt
  },
  data() {
    return {
      branchReceiptDialog: false,
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      qrlink: '',
      qrdialog: false,
      importloading: false,
      qrdata: '',
      showEdit: false,
      editdata: '',
      edittype: '',

      pagination: { rowsPerPage: -1, sortBy: 'department_store_id' },
      columnName: '',
      items: [],
      filter: {
        branchId: '',
        departmentStoreId: '',
        departmentStore: '',
        branch: ''
      },
      exportloading: false,
      showsearch: false,
      loading: false,
      headers: [
        { text: 'QR code', value: 'qr_code' },
        { text: 'รหัสของห้าง', value: 'department_store_id' },
        { text: 'รหัสสาขาของห้าง', value: 'branch_id' },
        { text: 'ชื่อห้าง', value: 'department_store' },
        { text: 'ชื่อสาขา', value: 'branch' },
        { text: '', value: '' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getBranch()
  },
  methods: {
    deleteBranch(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            var data = {
              branchId: item.branch_id,
              departmentStoreId: item.department_store_id,
              pageid: this.selectedBot.pageid
            }
            api.deletebranchtoacrm(data, (err, response) => {
              this.loading = false
              if (response.responsecode == 200) {
                this.getBranch()
                this.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
              }
            })
          }
        })
    },
    clearsearch() {
      this.filter = {
        branchId: '',
        departmentStoreId: '',
        departmentStore: '',
        branch: ''
      }
      this.getBranch()
      this.showsearch = false
    },
    onsearch() {
      this.getBranch()
      this.showsearch = false
    },
    async exportxlsx() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      this.exportloading = true
      api.gettoacrmBranch(data, (err, response) => {
        var exporteddata = response.data

        var json = exporteddata.map((el) => {
          return {
            รหัสสาขาของห้าง: el.branch_id,
            รหัสห้าง: el.department_store_id,
            ห้าง: el.department_store,
            สาขา: el.branch
          }
        })

        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'exportedbranch' + '.xlsx')
        this.exportloading = false
      })
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0]
      }
      api.toacrmimportbranch(data, async (err, response) => {
        this.importloading = false
        if (response.responsecode == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          this.getBranch()
        } else {
          await this.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getBranch()
      }
    },
    editBranch(item) {
      this.editdata = item
      this.edittype = 'edit'
      this.showEdit = true
    },
    onsave() {
      this.showEdit = false
      this.getBranch()
    },
    gotolink(link) {
      this.$nextTick(() => {
        window.location.href = link
      })
      // location.assign(this.qrlink)
    },
    showQrcode(item) {
      this.qrdialog = true
      this.qrdata = item
    },
    addBranch() {
      this.edittype = 'create'
      this.showEdit = true
    },
    getBranch() {
      var data = {
        pageid: this.selectedBot.pageid,
        branchId: this.filter.branchId, // filter รหัสสาขาของห้าง
        departmentStoreId: this.filter.departmentStoreId, // filter รหัสสาขา toa
        departmentStore: this.filter.departmentStore, // filter ชื่อห้าง
        branch: this.filter.branch, // filter ชื่อสาขา
        limit: this.limit,
        offset: this.offset
      }
      this.loading = true
      api.gettoacrmBranch(data, (err, response) => {
        this.loading = false
        this.items = response.data
        this.total = response.total
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Branch.vue